import React, { useEffect, useState } from 'react';
import ContactInfoStepPresenter from './ContactInfoStepPresenter';
import {
  useSchedulingContext,
  useSchedulingUpdateContext,
} from '../../../context';
import {
  ContactInfoDetails,
  Demographics,
  SchedulingTarget,
} from '../../../../api/models';

export interface ContactInfoStepWrapperProps {
  onContinue: () => void;
}

const ContactInfoStepWrapper: React.FC<ContactInfoStepWrapperProps> = (
  props: ContactInfoStepWrapperProps
) => {
  const schedulingDetails = useSchedulingContext();
  const schedulingUpdateContext = useSchedulingUpdateContext();

  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  useEffect(() => {
    if (loaded && schedulingDetails.contactInfoDetails) {
      props.onContinue();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schedulingDetails.contactInfoDetails]);

  const onPatientDemographicsChanged = (demographics: Demographics) => {
    schedulingUpdateContext.changeSchedulingDetails({
      ...schedulingDetails,
      patientDetails: {
        target:
          schedulingDetails.patientDetails?.target ?? SchedulingTarget.Myself,
        demographics: demographics,
      },
    });
  };

  const onContinue = (contactInfoDetails: ContactInfoDetails) => {
    schedulingUpdateContext.changeSchedulingDetails({
      ...schedulingDetails,
      contactInfoDetails: { ...contactInfoDetails },
    });
  };

  return (
    <ContactInfoStepPresenter
      schedulingDetails={schedulingDetails}
      onPatientDemographicsChanged={onPatientDemographicsChanged}
      onContinue={onContinue}
    />
  );
};

export default ContactInfoStepWrapper;
